/**
 * Load
 */

import Promise from 'promise-polyfill';

class Load {
  /**
   * @param {string} url - promise array
   * @param {string} method - get, post, put, delete
   * @param {string} data - data
   * @return {promise} result of the promise value.
   */
  static getJsonp( url, method = 'jsonp', data ) {

    if ( !url ) {
      return '';
    }

    return new Promise( ( resolve, reject ) => {
      jQuery.ajax({
      url,
      method,
      data,
      dataType: 'jsonp',
      cache: false,
      // xhrFields: {withCredentials: true},
      success: ( _data ) => { resolve( _data ); },
      error: ( _data ) => { reject( _data ); },
      });
    });
  }

  /**
   * @param {string} url - url
   * @param {string} method - get, post, put, delete
   * @param {object} data - data
   * @return {promise} result of the promise value.
   */
  static get( url, method = 'get', data = {} ) {

    if ( !url ) {
      return '';
    }

    return new Promise( ( resolve, reject ) => {
      jQuery.ajax({
        url,
        method,
        data,
        cache: false,
        xhrFields: { withCredentials: true },
        success: ( _data ) => { resolve( _data ); },
        error: ( _data ) => { reject( _data ); },
        contentType: ( method.toLowerCase() === 'get' ) ? 'application/json' : 'application/x-www-form-urlencoded',
      });
    });
  }

  /**
   * @param {array} _arr - promise array
   * @return {promise} result of the promise value.
   */
  static getAll( _arr ) {

    if ( !_arr && !_arr.length ) {
      return false;
    }

    const _data = {};
    const len = _arr.length;
    let successCount = 0;
    let failCount = 0;

    return new Promise( ( resolve, reject ) => {
      for ( let idx = 0; len > idx; ++idx ) {
        const _itemIdx = idx;
        const _item = _arr[ idx ];
        const _options = {
          url: _item.url,
          method: _item.method || 'get',
          data: _item.data,
          cache: false,
          success: ( data ) => {
            _data[ _item.boardAlias || _itemIdx ] = data;
            successCount++;
            if ( successCount + failCount >= len ) {
              resolve( _data );
            }
          },
          error: ( data ) => {
            _data[ _item.boardAlias || _itemIdx ] = data;
            failCount++;
            if ( successCount + failCount >= len ) {
              resolve( _data );
            }
          },
        };

        if ( _item.contentType ) {
          _options.contentType = _item.contentType;
        }

        jQuery.ajax( _options );
      }
    });
  }

  /**
   * @param {array} _arr - promise array
   * @return {promise} result of the promise value.
   */
  static getAllPromise( _arr ) {

    if ( !_arr && !_arr.length ) {
      return false;
    }

    const promiseArr = [];
    const len = _arr.length;

    for ( let idx = 0; len > idx; ++idx ) {
      const _item = _arr[ idx ];

      promiseArr.push ( new Promise( ( resolve, reject ) => {
        jQuery.ajax({
          url: _item.url,
          method: _item.method || 'get',
          data: _item.data,
          cache: false,
          success: ( data ) => { resolve( data ); },
          error: ( _data ) => { reject( _data ); },
        });
      }));
    }

    return Promise.all( promiseArr );
  }

  /**
   * @param {string} url
   * @param {function} callback
   * @param {string} type - css, js
   * @return {void} undefined
   */
  static loadFile( url, callback, type ) {
    let fileRef = '';

    if ( type === 'css' ) {
      fileRef = document.createElement( 'link' );
      fileRef.setAttribute( 'href', url );
      fileRef.setAttribute( 'type', 'text/css' );
      fileRef.setAttribute( 'rel', 'stlyesheet' );
    } else {
      fileRef = document.createElement( 'script' );
      fileRef.setAttribute( 'src', url );
      fileRef.setAttribute( 'type', 'text/javascript' );
    }

    if ( fileRef ) {
      document.getElementsByTagName( 'head' )[ 0 ].appendChild( fileRef );
    }

    if ( callback ) {
      callback();
    }
  }
}

export default Load;
